"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import TherapistMessageButtonWrapper from "../../../common/TherapistMessageButtonWrapper"

type Props = {
  formId: string
  cognitoId: string | null
  providerId: number | null | undefined
  userId: number | null
  groupLeaderUserId: number | null | undefined
  groupId: number | null
  groupName: string | null
  publicProviderMessageable?: boolean | null
}

export default function TherapistMessageButton({
  formId,
  cognitoId,
  providerId,
  userId,
  groupLeaderUserId,
  groupId,
  groupName,
  publicProviderMessageable,
}: Props) {
  return (
    <TherapistMessageButtonWrapper
      formId={formId}
      cognitoId={cognitoId}
      providerId={providerId}
      userId={userId}
      groupLeaderUserId={groupLeaderUserId}
      groupId={groupId}
      groupName={groupName}
      publicProviderMessageable={publicProviderMessageable}
      buttonText="Send Therapist Message"
    />
  )
}
